// removed by extract-text-webpack-plugin
module.exports = {"main-content":"main-content__2KLyH","sticky":"sticky__CSrbG","show-in-mobile":"show-in-mobile__32PAJ","show-in-web":"show-in-web__2Djrg","make-flex":"make-flex__2Uz_Y","web-content":"web-content__2Su3f","text-decorate":"text-decorate__29Joh","nav1":"nav1__2AlLM","mobile-content":"mobile-content__1BeRB","carret-btn":"carret-btn__2uLvM"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss/elssnav.scss
// module id = 622
// module chunks = 68